import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import SocialShare from '../../Shared/SocialShare';
import Select from '../../../Core/Select';

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.neutral_1')};
`;

export const StyledContainer = styled(Container)`
  padding: 80px 0px 55px;
  position: relative;

  @media only screen and (max-width: calc(${themeGet(
      'breakpoints.md'
    )} - 1px)) {
    ${Wrapper}.filter-active & {
      padding-bottom: 0;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 85px 0 60px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 85px 90px 60px;
  }
`;

export const Title = styled.h1`
  margin-bottom: 15px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    letter-spacing: 0.5px;
  }
`;

export const SubTitle = styled.h2`
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: 26px;
    line-height: 38px;
    font-weight: 700;
  }
`;

export const Controls = styled.div`
  display: flex;
  flex-direction: column-reverse;
  margin-top: 70px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-top: 90px;
  }
`;

export const Social = styled(SocialShare)`
  display: flex;
  align-items: center;

  && {
    margin: 35px -15px 0;
  }

  li {
    margin: 0 15px;

    max-height: 24px;
    max-width: 24px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    && {
      margin-top: 0;
    }

    position: absolute;
    top: 170px;
    right: 0px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    right: 90px;
  }
`;

export const StyledSelectLabel = styled.span`
  color: #000000;
  font-family: ${themeGet('fonts.primary')};
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.35px;
  line-height: 38px;
  position: absolute;
  pointer-events: none;
  background-color: white;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  max-width: 278px;
  /* margin-top: 30px; */

  // * The main control div
  .react-select__control {
    border: none;
    border-radius: 0px;
    justify-content: flex-start;
    cursor: pointer;
  }

  .react-select__value-container {
    padding-left: 0;
  }

  // * Placeholder styling
  .react-select__placeholder {
    color: #000000;
    font-family: ${themeGet('fonts.primary')};
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.35px;
    line-height: 38px;
  }

  // * Vertical line that seperates the placeholder from the indicator
  .react-select__indicator-separator {
    display: none;
  }

  .react-select__option,
  .react-select__single-value {
    font-family: ${themeGet('fonts.primary')};
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.35px;
    line-height: 38px;
  }

  .react-select__menu {
    width: 100%;
  }

  .react-select__menu-list {
  }

  .react-select__option {
  }

  .react-select__indicators {
    svg {
      fill: black;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 0;
    margin-right: 30px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
  }
`;
